import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity10 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_10;
}

export default GravelRoadTileEntity10;
